<template>
  <div class="live-prize-list">
    <div class="prize-header" v-if="total || isSearch">
      <div class="prize-header_left">
        <vh-button size="medium" type="primary" @click="createPrize" round>
          {{ $t('host.k_572001') }}
        </vh-button>
        <vh-button
          size="medium"
          type="info"
          plain
          @click="prizeMaterial"
          round
          v-if="configList?.hidden_asset_library != 1"
        >
          {{ $t('host.k_572002') }}
        </vh-button>
        <vh-button
          size="medium"
          type="info"
          plain
          round
          :disabled="!prizeChecked.length"
          class="transparent-btn"
          @click="allPrizeDelete"
        >
          {{ $t('host.k_572003') }}
        </vh-button>
        <div class="left_switch">
          <span>{{ $t('host.k_572004') }}</span>
          <vh-switch
            v-model="prizeStatus"
            active-color="#fb3a32"
            inactive-color="#cecece"
          ></vh-switch>
        </div>
      </div>
      <div class="prize-header_right">
        <vh-input
          clearable
          @clear="searchTableList"
          @keyup.enter.native="searchTableList"
          v-model="keyword"
          :placeholder="$t('host.k_572005')"
        >
          <i
            class="vh-icon-search vh-input__icon"
            slot="prefix"
            style="cursor: pointer; line-height: 36px"
            @click="searchTableList"
          ></i>
        </vh-input>
        <vh-button type="primary" round @click="surePrizeInfo" v-preventReClick>
          {{ $t('host.k_572006') }}
        </vh-button>
      </div>
    </div>
    <div class="prize-list">
      <template v-if="total || isSearch">
        <div class="prize-list_wrapper">
          <vh-table
            :data="prizeList"
            ref="tableList"
            style="width: 100%"
            row-key="award_id"
            @selection-change="handleSelectionChange"
            @select-all="checkAllQuestion"
          >
            <!-- 无数据展示 -->
            <template slot="empty">
              <img src="@/app-shared/assets/img/no-search.png" />
              <p>{{ $t('host.k_572007') }}</p>
            </template>
            <!-- 有数据表格 -->
            <vh-table-column type="selection" width="55" align="left" />
            <vh-table-column prop="src" :label="$t('host.k_572008')">
              <template slot-scope="scope">
                <div class="prize-img">
                  <img :src="scope.row.award_img_url" alt="" />
                </div>
              </template>
            </vh-table-column>
            <vh-table-column
              prop="award_name"
              :label="$t('host.k_572009')"
              width="150"
            ></vh-table-column>
            <vh-table-column
              prop="award_desc"
              :label="$t('host.k_572010')"
              width="150"
              :show-overflow-tooltip="true"
            ></vh-table-column>
            <vh-table-column :label="$t('host.k_572011')" width="120">
              <template slot-scope="scope">
                <span>{{ awardTypeFilter(scope.row.award_type) }}</span>
              </template>
            </vh-table-column>
            <vh-table-column
              prop="quantity"
              :label="$t('host.k_572012')"
              width="90"
            ></vh-table-column>
            <vh-table-column
              prop="create_time"
              :label="$t('host.k_572013')"
              width="160"
            ></vh-table-column>
            <vh-table-column :label="$t('host.k_572014')" width="160" fixed="right">
              <template slot-scope="scope">
                <vh-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('host.k_572015')"
                  placement="top"
                >
                  <i
                    class="vh-iconfont vh-line-copy"
                    v-if="scope.row.award_type != 1"
                    @click="copePrize(scope.row.award_id)"
                  ></i>
                </vh-tooltip>
                <vh-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('host.k_572016')"
                  placement="top"
                >
                  <i class="vh-iconfont vh-line-el-icon-edit" @click="editPrize(scope.row)"></i>
                </vh-tooltip>
                <vh-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('host.k_572017')"
                  placement="top"
                >
                  <i
                    class="vh-iconfont vh-line-delete"
                    @click="deletePrize(scope.row.award_id)"
                  ></i>
                </vh-tooltip>
                <vh-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('host.k_572018')"
                  placement="top"
                >
                  <i class="vh-iconfont vh-line-rank"></i>
                </vh-tooltip>
              </template>
            </vh-table-column>
          </vh-table>
        </div>
        <!-- <div class="prize-list_btn">
        <vh-button
          size="medium"
          round
          class="transparent-btn"
          @click="returnStep('list')"
          v-preventReClick
        >
          返回列表
        </vh-button>
        <vh-button size="medium" v-preventReClick @click="returnStep('reward')" round>
          上一步
        </vh-button>
        <vh-button type="primary" round @click="surePrizeInfo" v-preventReClick>{{ $t('host.k_572006') }}</vh-button>
      </div> -->
      </template>
      <div class="prize-list_null" v-else>
        <span class="null-img"><img src="../../img/no-file.png" alt="" /></span>
        <p>{{ $t('host.k_572019') }}</p>
        <p>
          <vh-button size="medium" type="primary" @click="createPrize" round>
            {{ $t('host.k_572001') }}
          </vh-button>
          <vh-button
            size="medium"
            type="info"
            plain
            @click="prizeMaterial"
            round
            v-if="configList?.hidden_asset_library != 1"
          >
            {{ $t('host.k_572002') }}
          </vh-button>
        </p>
      </div>
    </div>
    <create-prize ref="createPrize" @getTableList="getTableList"></create-prize>
  </div>
</template>
<script>
  import { useLotteryServer } from 'middle-domain';
  import createPrize from '../dialogs/create-prize.vue';
  import Sortable from 'sortablejs';
  export default {
    data() {
      return {
        prizeList: [],
        prizeChecked: [],
        total: 0,
        maxPage: 1,
        isSearch: false,
        keyword: '',
        isCheckAll: false,
        prizeStatus: false,
        prizeInfo: {} //编辑信息
      };
    },
    components: {
      createPrize
    },
    computed: {
      lotteryId() {
        return this.lotteryServer.state.lotteryLiveId;
      },
      configList() {
        return this.$domainStore.state.roomBaseServer.configList;
      }
    },
    beforeCreate() {
      this.lotteryServer = useLotteryServer({
        mode: 'live'
      });
    },
    created() {
      // this.initComponent();
    },
    methods: {
      awardTypeFilter(val) {
        const map = {
          0: this.$t('host.k_572020'),
          1: this.$t('host.k_572021'),
          3: this.$t('host.k_572022')
        };
        return map[val];
      },
      // 返回列表
      returnStep(name) {
        this.isCheckAll = false;
        this.$emit('returnStep', name);
      },
      initComponent() {
        if (this.lotteryId) {
          this.keyword = '';
          this.getTableList();
        }
      },
      searchTableList() {
        if (this.keyword) {
          try {
            if (this.$refs.tableList) {
              this.$refs.tableList.clearSelection();
            }
          } catch (e) {
            console.log(e);
          }
          this.getTableList('search');
        } else {
          this.getTableList();
        }
      },
      getTableList(search) {
        let formParams = {
          award_name: this.keyword,
          pos: 0,
          limit: 20
        };
        this.isSearch = search ? true : false;
        this.lotteryServer.getLivePrizeList(formParams).then(res => {
          this.total = res.data.total;
          this.prizeList = res.data.list;
          this.prizeStatus = Boolean(res.data.can_look_award_pool);
          this.total && this.setRowSort();
          if (this.isCheckAll) {
            this.$refs.tableList.toggleAllSelection();
            this.isCheckAll = false;
          }
        });
      },
      setRowSort() {
        this.$nextTick(() => {
          // 修复当el-table列配置了fixed="right"后，拖拽无效
          // https://github.com/SortableJS/Sortable/issues/2190
          let dom = document.querySelector('.vh-table .vh-table__fixed-body-wrapper tbody');
          Sortable.create(dom, {
            ghostClass: '',
            handle: '.vh-line-rank',
            onEnd: ({ newIndex, oldIndex }) => {
              this.prizeList.splice(newIndex, 0, this.prizeList.splice(oldIndex, 1)[0]);
              let newArray = this.prizeList.slice(0);
              this.prizeList = [];
              this.$nextTick(() => {
                this.prizeList = newArray;
              });
            }
          });
        });
      },
      // 保存
      surePrizeInfo() {
        const list = this.total && this.prizeList.map(item => item.award_id);
        let params = {
          can_look_prize_pool: Number(this.prizeStatus),
          award_ids: list.join(',')
        };
        this.lotteryServer
          .saveLivePrizeInfo(params)
          .then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('host.k_572023'));
              this.$emit('success', { type: 'prize', act: 'save' });
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(e => {
            this.$message.error(e.msg);
          });
      },
      copePrize(id) {
        if (Number(this.total) >= 20) {
          this.$message.error(this.$t('host.k_572024'));
          return;
        }
        this.lotteryServer
          .copyLivePrize(id)
          .then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('host.k_572025'));
              this.$emit('success', { type: 'prize', act: 'copy' });
              this.getTableList();
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(e => {
            this.$message.error(e.msg);
          });
      },
      editPrize(item) {
        this.$refs.createPrize.openCreatePrize(this.$t('host.k_572016'), item);
      },
      // 批量删除
      allPrizeDelete(id) {
        id = this.prizeChecked.join(',');
        this.deletePrize(id);
      },
      // 删除
      deletePrize(id) {
        this.$vhConfirm(this.$t('host.k_572026'), this.$t('host.k_572027'), {
          confirmButtonText: this.$t('host.k_572028'),
          cancelButtonText: this.$t('host.k_572029'),
          closeOnClickModal: false,
          roundButton: true
        }).then(() => {
          let params = {
            award_ids: id
          };
          this.lotteryServer
            .delLivePrize(params)
            .then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('host.k_572030'));
                this.$emit('success', { type: 'prize', act: 'delete' });
                this.getTableList();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(e => {
              this.$message.error(e.msg);
            });
        });
      },
      checkAllQuestion(selection) {
        // 全选
        this.isCheckAll = selection && selection.length > 0;
        this.prizeChecked = selection.map(item => item.award_id);
      },
      // 选中
      handleSelectionChange(val) {
        this.prizeChecked = val.map(item => item.award_id);
      },
      createPrize() {
        if (Number(this.total) >= 20) {
          this.$message.error(this.$t('host.k_572024'));
          return;
        }
        this.$refs.createPrize.openCreatePrize(this.$t('host.k_572031'));
      },
      // 资料库
      prizeMaterial() {
        this.$refs.createPrize.openPrizeMaterial();
      }
    }
  };
</script>
<style lang="less">
  .live-prize-list {
    height: 500px;
    .prize-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &_left {
        display: flex;
        align-items: center;
        .left_switch {
          span {
            padding: 0 8px 0 12px;
            vertical-align: middle;
          }
        }
      }
      &_right {
        display: flex;
        align-items: center;
        .vh-input {
          margin-right: 16px;
        }
        .vh-input__inner {
          border-radius: 20px;
          height: 36px;
          background: transparent;
        }
      }
    }
    .prize-list {
      padding-top: 18px;
      &_wrapper {
        height: 426px;
        overflow: auto;
        .prize-img {
          width: 60px;
          height: 60px;
          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
        }
        .vh-iconfont {
          padding: 0 6px;
          cursor: pointer;
        }
      }
      &_switch {
        display: flex;
        padding-top: 24px;
        p {
          padding-left: 12px;
          font-size: 14px;
        }
      }
      &_null {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 80px;
        .null-img {
          display: inline-block;
          width: 120px;
          height: 120px;
          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
        }
        p {
          font-size: 14px;
          padding: 10px 0;
        }
      }
      &_btn {
        padding: 32px 0 12px;
        border-top: 1px solid #ebeef5;
        text-align: center;
      }
      .vh-table__empty-block {
        padding-top: 50px;
      }
      .vh-table::before {
        height: 0;
      }
    }
  }
</style>
